module.exports = __webpack_public_path__ + "img/natural-science-and-technology.b5c58a51.svg";